import Spacings from '../theme/common/spacings';

const background = {
  bgcolor: 'neutral.20',
  paddingY: Spacings.medium2,
};

const navigation = {
  display: 'grid',
  gridAutoFlow: { sm: 'column' },
  columnGap: { sm: Spacings.small4, md: Spacings.medium2, lg: '92px' },
  gridTemplateColumns: {
    md: 'minmax(0, 250px) minmax(0, 340px) minmax(0, 320px)',
  },
  justifyItems: { sm: 'center', md: 'normal' },
  marginBottom: {
    xs: Spacings.medium4,
    sm: Spacings.medium2,
    md: 0,
  },
};

export default {
  background,
  navigation,
};
